import React from "react";
import { Box } from "@origin-digital/ods-core";
import { TasksTable } from "src/components/Tasks";

export const ContentSection = () => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      data-id="contentSection.root"
    >
      <TasksTable />
    </Box>
  );
};
